
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibag() {



  const cardData =
  {
    keyword: 'Pune to Alibag Cabs',
    heading: 'AB Ghule Cabs: Pune to Alibag Cabs',
    headingDescription: 'Planning a beach vacation or a relaxing getaway to Alibag from Pune? Look no further than AB Ghule Cabs for reliable, comfortable, and affordable taxi services. With well-maintained vehicles and experienced drivers, we ensure that your trip to this coastal paradise is smooth, safe, and enjoyable. The approximate distance from Pune to Alibag is around 140 km.',

    top: 'Top Places to Visit in Alibag with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Alibag Beach",
    description: "Alibag Beach is the most popular attraction in the town. With its clean sands and gentle waves, it’s perfect for relaxing, swimming, and enjoying the coastal beauty."
  },
  {
    title: "Kolaba Fort",
    description: "This historic sea fort, located off the coast, offers a glimpse into the region’s rich maritime history. It’s accessible by boat and provides stunning views of the Arabian Sea."
  },
  {
    title: "Nagaon Beach",
    description: "Nagaon Beach is known for its tranquility and water sports activities. It’s a great spot for families and adventure enthusiasts looking to engage in water activities like jet-skiing and parasailing."
  },
  {
    title: "Kihim Beach",
    description: "Kihim Beach is a peaceful destination with golden sands and lush greenery. Ideal for a quiet retreat, it offers spectacular views and a calm environment."
  },
  {
    title: "Mandwa Beach",
    description: "Located near Alibag, Mandwa Beach is known for its scenic beauty and serene environment. It’s a great spot for those looking to enjoy a peaceful beach day away from the crowds."
  },
  {
    title: "Alibag Fort",
    description: "A historic site, Alibag Fort offers panoramic views of the sea and the surrounding landscape. It’s a great place for history buffs and nature lovers."
  },
  {
    title: "Saswane Beach",
    description: "Known for its clean and relatively less crowded surroundings, Saswane Beach is perfect for a relaxing day. The beach is surrounded by scenic beauty, making it a great spot for a peaceful picnic."
  },
  {
    title: "Rewas Beach",
    description: "Rewas Beach is a hidden gem, offering a tranquil atmosphere and beautiful views. It’s perfect for nature walks and unwinding in peace."
  },
  {
    title: "Phansad Wildlife Sanctuary",
    description: "Located on the way to Alibag, Phansad Wildlife Sanctuary is a haven for nature lovers. The sanctuary is home to a variety of birds, animals, and lush vegetation, making it a perfect spot for wildlife enthusiasts."
  },
  {
    title: "Kanakeshwar Forest",
    description: "A short drive from Alibag, Kanakeshwar Forest offers nature trails and a peaceful environment. It’s a great spot for a short hike, birdwatching, and enjoying the beauty of nature."
  }
],


 services: [
    {
      "name": "Pune to Alibag Cabs",
      description: "Travel comfortably from Pune to Alibag with AB Ghule Cabs. We offer a range of vehicles to make your journey pleasant and convenient, whether you're traveling solo, with family, or in a group."
    },
    {
      "name": "Pune to Alibag Taxi Booking",
      description: "Book your taxi from Pune to Alibag online with AB Ghule Cabs. Our user-friendly booking process ensures a hassle-free experience, and we provide a variety of vehicle options to meet your needs."
    },
    {
      "name": "Pune to Alibag Taxi Rates",
      description: "Get the best rates for your trip from Pune to Alibag with AB Ghule Cabs. We offer competitive taxi rates, ensuring that your journey is both affordable and comfortable."
    },
    {
      "name": "Pune to Alibag Cab Charges",
      description: "Our Pune to Alibag cab charges are transparent and cost-effective. No hidden fees—just straightforward pricing that makes your travel experience stress-free."
    },
    {
      "name": "Pune to Alibag Cab Pricing",
      description: "Check out our competitive cab pricing for your trip from Pune to Alibag. We provide clear and affordable pricing for various vehicle options to make your trip more enjoyable."
    },
    {
      "name": "Pune to Alibag Private Car Hire",
      description: "If you prefer privacy and comfort, book a private car hire for your trip from Pune to Alibag. AB Ghule Cabs offers a range of vehicles, including luxury options for a seamless travel experience."
    },
    {
      "name": "Pune to Alibag Cab Cost",
      description: "The cost for your cab from Pune to Alibag depends on factors like vehicle type and the distance. With AB Ghule Cabs, you get the best value for your money with no surprise charges."
    },
    {
      "name": "Pune to Alibag Taxi Service",
      description: "AB Ghule Cabs offers reliable taxi services from Pune to Alibag. Whether you’re heading for a short trip or planning a one-day getaway, we ensure your journey is comfortable, timely, and affordable."
    },
    {
      "name": "Pune to Alibag Cab",
      description: "Book your cab from Pune to Alibag with AB Ghule Cabs for a smooth and comfortable ride. Our fleet of vehicles, including sedans and SUVs, ensures a safe journey to your destination."
    },
    {
      "name": "Pune to Alibaug Cab Fare",
      description: "Plan your trip with confidence by knowing the Pune to Alibaug cab fare upfront. Our competitive prices ensure a hassle-free experience, whether you're booking for a one-way or round trip."
    },
    {
      "name": "Pune to Alibag Round Trip",
      description: "Looking for a round-trip ride from Pune to Alibag? AB Ghule Cabs offers affordable and convenient round-trip packages, making it easier for you to travel back and forth without any worries."
    },
    {
      "name": "Pune to Alibag Cabs",
      description: "Choose from a range of cabs available for your Pune to Alibag journey. Whether you prefer a sedan, SUV, or luxury car, we have the perfect vehicle for your needs."
    },
    {
      "name": "Pune to Alibag Innova Crysta",
      description: "Book an Innova Crysta for your journey from Pune to Alibag. Known for its spacious interior and comfort, this vehicle is ideal for family trips or group travel."
    },
    {
      "name": "Pune to Alibag Tempo Traveller on Rent",
      description: "For group travel, rent a Tempo Traveller from Pune to Alibag. With ample space and comfort, our Tempo Travellers are perfect for large groups or corporate outings."
    },
    {
      "name": "Pune to Alibag Sedan Cab Service",
      description: "AB Ghule Cabs offers sedan cab services for your trip from Pune to Alibag. Whether you prefer a Swift Dzire, Toyota Etios, or similar vehicle, we ensure a smooth and comfortable ride."
    },
    {
      "name": "Pune to Alibag Swift Taxi Service",
      description: "Our Swift Dzire taxis are available for hire from Pune to Alibag, providing a comfortable and budget-friendly option for those traveling in smaller groups."
    },
    {
      "name": "Pune to Alibaug Kia Carens Taxi Service",
      description: "Travel in style and comfort with a Kia Carens on rent for your trip to Alibag. The Kia Carens is perfect for those seeking luxury and convenience during their travels."
    },
    {
      "name": "Pune to Alibaug One Day Trip Cab Package",
      description: "If you're planning a one-day trip from Pune to Alibaug, AB Ghule Cabs offers an all-inclusive package. With a one-day trip package, you can explore the best attractions in Alibaug while enjoying a comfortable ride."
    },
    {
      "name": "Pune to Alibag Cabs Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Alibag Cabs. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Pune to Alibag Cabs", "-Pune to Alibag Taxi Booking"],
    ["Pune to Alibag Taxi Rates", "-Pune to Alibag Cab Charges"],
    ["Pune to Alibag Cab Pricing", "-Pune to Alibag Private Car Hire"],
    ["Pune to Alibag Cab Cost", "-Pune to Alibag Taxi Service"],
    ["Pune to Alibag Cab", "-Pune to Alibaug cab fare"],
    ["Pune to alibaug round trip", "-Pune to alibag cabs"],
    ["Pune to alibag innova crysta", "-pune to alibaug tempo traveller on rent"],
    ["Pune to alibag sedan cab service", "-pune to alibag sedan cab service"],
    ["Pune to alibag swift taxi service", "-pune to alibaug kia carens taxi service"],
    ["Pune to alibaug one day trip cab package", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Comfortable Service",
      WhyChoosedescription: "AB Ghule Cabs offers a reliable and comfortable taxi service for your journey from Pune to Alibag. Whether you're visiting for a relaxing weekend getaway or a day trip, we ensure your ride is comfortable and stress-free."
    },
    {
      WhyChooseheading: "Competitive and Transparent Pricing",
      WhyChoosedescription: "We provide affordable and transparent pricing, ensuring you get great value for your money. Our pricing structure has no hidden charges, so you can plan your trip with complete confidence."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "Our vehicles are well-maintained, clean, and regularly serviced to provide you with a safe and pleasant ride. You can choose from a range of vehicles, including sedans, SUVs, and luxury cars, depending on your preference and needs."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our experienced and professional drivers are knowledgeable about the best routes to Alibag, ensuring you reach your destination safely and on time. They are courteous and trained to provide top-notch customer service."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "We value your time. Our drivers will always be punctual for your pick-up in Pune, ensuring a smooth journey to Alibag without any delays."
    },
    {
      WhyChooseheading: "Easy and Convenient Booking Process",
      WhyChoosedescription: "Booking your taxi from Pune to Alibag is easy with AB Ghule Cabs. You can book online through our website or app, or simply call our customer service for assistance."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We are available 24/7 to cater to your travel needs. Whether it’s an early morning departure or a late-night booking, we are always ready to serve you."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Alibag?',
      answer: 'You can easily book your taxi online through our website, mobile app, or by calling our customer service team for assistance.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Alibag?',
      answer: 'The one-way fare for a sedan typically ranges from ₹3,000 to ₹3,800. The exact fare depends on the vehicle type and other factors.',
    },
    {
      id: 'FAQ3',
      question: 'Are the fares inclusive of taxes and tolls?',
      answer: 'Yes, all fares are inclusive of taxes, tolls, and other charges. There are no hidden fees.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Alibag take?',
      answer: 'The journey typically takes between 3.5 to 4.5 hours, depending on traffic conditions and the route taken.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round trip from Pune to Alibag?',
      answer: 'Yes, we offer round-trip bookings. You can contact us for details and to get the best rates for your return trip as well.',
    },
    {
      id: 'FAQ6',
      question: 'Do you offer pick-up from any location in Pune?',
      answer: 'Yes, we provide pick-up from any location in Pune, including homes, offices, hotels, and more.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are air-conditioned for your comfort throughout the journey.',
    },
    {
      id: 'FAQ8',
      question: 'Can I choose the vehicle for my trip?',
      answer: 'Yes, you can choose from a range of vehicles, including sedans, SUVs, and luxury cars, depending on your needs.',
    },
    {
      id: 'FAQ9',
      question: 'How do I pay for the taxi service?',
      answer: 'You can pay via cash, credit/debit card, or through our mobile app, making the payment process quick and easy.',
    },
    {
      id: 'FAQ10',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, and these will be communicated to you in advance.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arvind Patil',
      feedback: 'I had a wonderful trip from Pune to Alibag with AB Ghule Cabs. The driver was very professional, and the vehicle was clean and comfortable. We reached Alibag on time and had a relaxing experience. I will definitely use their services again.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Neha Sharma',
      feedback: 'AB Ghule Cabs provided an excellent service for our trip from Pune to Alibag. The driver was courteous and made sure we had a smooth and safe ride. The booking process was also very easy, and the fare was reasonable. Highly recommend!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Alibag Cabs | Affordable Taxi & Car Rental Services</title>
  <meta name="description" content="Book a taxi from Pune to Alibag with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Alibag Cabs, Pune to Alibag Taxi Booking, Pune to Alibag Taxi Rates, Pune to Alibag Cab Charges, Pune to Alibag Cab Pricing, Pune to Alibag Private Car Hire, Pune to Alibag Cab Cost, Pune to Alibag Taxi Service, Pune to Alibag Cab, Pune to Alibaug Cab Fare, Pune to Alibaug Round Trip, Pune to Alibag Cabs, Pune to Alibag Innova Crysta, Pune to Alibaug Tempo Traveller on Rent, Pune to Alibag Sedan Cab Service, Pune to Alibag Swift Taxi Service, Pune to Alibaug Kia Carens Taxi Service, Pune to Alibaug One Day Trip Cab Package" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Alibag Cabs | Affordable Taxi & Car Rental Services" />
  <meta property="og:description" content="Book a taxi from Pune to Alibag with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-alibag-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-alibag-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Alibag Cabs",
        description: "Book a taxi from Pune to Alibag with AB Ghule Cabs. Get the best fares for one-way and round trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-alibag-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-alibag-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-alibag-cabs.jpg",
        "priceRange": "₹2000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-alibag-cabs",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "80"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh S"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "Booked an Innova Crysta for a family trip to Alibag. The experience was seamless, and the car was in excellent condition. Highly recommend!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suman P"
            },
            "datePublished": "2024-09-30",
            "reviewBody": "We opted for a one-day trip to Alibag in a Swift Dzire. The driver was courteous, and the trip was very comfortable. Thank you, AB Ghule Cabs!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Alibag Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.6104",
            "longitude": "72.8837"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-alibag-cabs"
        },
        "keywords": "Pune to Alibag Cabs, Pune to Alibag Taxi Booking, Pune to Alibag Taxi Rates, Pune to Alibag Cab Charges, Pune to Alibag Cab Pricing, Pune to Alibag Private Car Hire, Pune to Alibag Cab Cost, Pune to Alibag Taxi Service, Pune to Alibag Cab, Pune to Alibaug Cab Fare, Pune to Alibaug Round Trip, Pune to Alibag Cabs, Pune to Alibag Innova Crysta, Pune to Alibaug Tempo Traveller on Rent, Pune to Alibag Sedan Cab Service, Pune to Alibag Swift Taxi Service, Pune to Alibaug Kia Carens Taxi Service, Pune to Alibaug One Day Trip Cab Package"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/52.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetoalibag;